import * as types from '../../actions/actiontypes';

export default function userSearchReducer(state = {}, action) {
	switch (action.type) {
		case types.GET_USER_SEARCH: {
			const {key} = action;
			const newState = {...state, [key]: action.response || null};
			return newState;
		}
		default:
			return state;
	}
}
